module.exports = "/images/vasterbergslagens_elforsaljning_ab.png?e083855a90ddaf4c96c4363963f360e3";